/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import logo from '../../../assets/images/logo.png';
import { Container } from './styles';
import api from '~/services/api';
import history from '~/services/history';

export default function SignIn() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showLogin, setShowLogin] = useState(false);
  const { id } = useParams();

  const handlePassword = (e) => {
    const { value } = e.target;
    setPassword(value);
  };

  const handleConfirmPassword = (e) => {
    const { value } = e.target;
    setConfirmPassword(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (password === confirmPassword) {
        await api.put('/passwords', { token: id, password });
        setShowLogin(true);

        return toast.success('Senha atualizada com sucesso.');
      }
      return toast.error('As senhas precisam ser idênticas.');
    } catch (error) {
      return toast.error('Erro ao atualizar a senha, tente novamente.');
    }
  }

  return (
    <Container>
      <img src={logo} alt="Apollo" />

      <p>Crie sua nova senha:</p>

      <form>
        <input
          type="password"
          placeholder="Nova Senha"
          onChange={handlePassword}
        />
        <input
          type="password"
          placeholder="Confirmar Nova Senha"
          onChange={handleConfirmPassword}
        />

        <button type="submit" onClick={(e) => handleSubmit(e)}>
          <p>RESETAR SENHA</p>
        </button>

        {showLogin === true ? (
          <button type="submit" onClick={() => history.push('/')}>
            <p>FAZER LOGIN</p>
          </button>
        ) : null}
      </form>
    </Container>
  );
}
